export const initTheme = (mode, variant) => {

    if (mode === "kung") {
        import("./kung.css");
        return;
    }

    if (mode === "dbet") {
        import("./dbet.css");
        return;
    }

    if (mode === "orange") {
        if (variant === "light") {
            import("./orange_light.css");
            return;
        }
        import("./orange.css");
        return;
    }

    if (mode === "wood") {
        import("./wood.css");
        return;
    }

    if (mode === "lion") {
        import("./lion.css");
        return;
    }

    if (mode === "video") {
        import("./video.css");
        return;
    }

    if (mode === "mrvegas") {
        import("./mrvegas.css");
        return;
    }

    if (mode === "green") {
        import("./green.css");
        return;
    }

    if (mode === "comeon") {
        import("./comeon.css");
        return;
    }

    if (mode === "hajper") {
        import("./hajper.css");
        return;
    }

    if (mode === "snabbare") {
        import("./snabbare.css");
        return;
    }

    if (mode === "reviant") {
        import("./reviant.css");
        return;
    }

    if (mode === "mega") {
        import("./mega.css");
        return;
    }

    if (mode === "lyllo") {
        import("./lyllo.css");
        return;
    }

    if (mode === "stugan") {
        import("./stugan.css");
        return;
    }

    if (mode === "kryss") {
        import("./kryss.css");
        return;
    }

    if (mode === "hard") {
        import("./hard.css");
        return;
    }

    if (mode === "gogo") {
        import("./gogo.css");
        return;
    }

    import("./standard.css");
}